module.exports = __webpack_public_path__ + "img/party-logo.47f90a5d.png";